import { memo } from "react";
import { LEAKAGES, OBJECTIONS, URGENCY_LEVELS, YES_NO_PARTIAL } from "../../data/scorecard";
import TextInput from "/src/components/UI/TextField/TextInput";
import TextArea from "/src/components/UI/TextField/TextArea";
import { CardTitle, Field, SegmentedChoice, SelectField } from "../shared";

function CallSummaryCard({ summary, onChange, suggestedLeakage }) {
    return (
        <section className="ce-card">
            <CardTitle
                icon="fas fa-bullseye"
                title="Call summary"
                hint="What the dashboard counts: where the call leaked and how it was handled"
            />

            <div className="ce-grid ce-grid--3">
                <Field label="Primary coaching leakage">
                    <SelectField name="leakage" value={summary.leakage} options={LEAKAGES} placeholder="Select a leakage…" onChange={(value) => onChange("leakage", value)} />
                    {suggestedLeakage && summary.leakage !== suggestedLeakage && (
                        <button type="button" className="ce-suggest" onClick={() => onChange("leakage", suggestedLeakage)}>
                            <i className="fas fa-lightbulb"></i> Suggested from scores: <b>{suggestedLeakage}</b> — use it
                        </button>
                    )}
                </Field>
                <Field label="Main objection">
                    <SelectField name="objection" value={summary.objection} options={OBJECTIONS} placeholder="Select an objection…" onChange={(value) => onChange("objection", value)} />
                </Field>
                <Field label="Urgency">
                    <SelectField name="urgency" value={summary.urgency} options={URGENCY_LEVELS} placeholder="Select…" onChange={(value) => onChange("urgency", value)} />
                </Field>

                <Field label="First close attempt (min)">
                    <TextInput className="ce-w100" type="number" min="0" placeholder="e.g. 12" value={summary.firstCloseMin}
                        onChange={(event) => onChange("firstCloseMin", event.target.value)} />
                </Field>
                <Field label="Close attempts">
                    <TextInput className="ce-w100" type="number" min="0" placeholder="0" value={summary.closeAttempts}
                        onChange={(event) => onChange("closeAttempts", event.target.value)} />
                </Field>
                <Field label="Priority shift achieved">
                    <SegmentedChoice
                        options={YES_NO_PARTIAL}
                        value={summary.priorityShift}
                        tones={{ Yes: "green", Partially: "orange", No: "pink" }}
                        ariaLabel="Priority shift achieved"
                        onChange={(value) => onChange("priorityShift", value)}
                    />
                </Field>
            </div>

            <div className="ce-grid ce-grid--2">
                <Field label="Best moment of the call">
                    <TextArea className="input ce-w100" rows={3} placeholder="The moment worth replaying to the team"
                        value={summary.bestMoment} onChange={(event) => onChange("bestMoment", event.target.value)} />
                </Field>
                <Field label="Coaching priority">
                    <TextArea className="input ce-w100" rows={3} placeholder="The exact pivotal timestamp and ONE behavior for the next calls"
                        value={summary.coachingPriority} onChange={(event) => onChange("coachingPriority", event.target.value)} />
                </Field>
            </div>
        </section>
    );
}

export default memo(CallSummaryCard);
